import script from "./DocumentClassificationView.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentClassificationView.vue?vue&type=script&setup=true&lang=js"

import "./DocumentClassificationView.vue?vue&type=style&index=0&id=15d92f26&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-15d92f26"]])

export default __exports__